//Add the common constant

export const mockDataForPropert = {
  grandTotalCompleted: 1,
  grandTotalAttention: 0,
  propertyFields: [
    {
      clientName: "PropShield",
      propertyMasterId: "6865117e-f5ed-4a0c-86ef-24b0e82a95d2",
      propertyName: "Greenwood Towers",
      propertyLocation: "456 Oak Avenue, Rivertown",
      inspectedBy: "john.doe",
      lastInspectionDate: "2025-06-25T10:30:00",
      status: "Completed",
      totalCompleted: 1,
      totalAttention: 0,
    },
    {
      clientName: "PropShield",
      propertyMasterId: "972e9cb4-b017-4fce-b2d5-947286b065df",
      propertyName: "Sunrise Villas",
      propertyLocation: "55 Morning Dr, Pleasantville",
      inspectedBy: "mike.lee",
      lastInspectionDate: "2025-06-23T10:45:00",
      status: "In Review",
      totalCompleted: 0,
      totalAttention: 0,
    },
    {
      clientName: "PropShield",
      propertyMasterId: "f204c245-37d1-4650-919f-d9aed796d611",
      propertyName: "Meadow View Estates",
      propertyLocation: "321 Meadow Rd, Hilltown",
      inspectedBy: "anna.green",
      lastInspectionDate: "2025-06-22T14:30:00",
      status: "Pending Approval",
      totalCompleted: 0,
      totalAttention: 0,
    },
  ],
};

export const dummyTableData = [
  {
    doorReference: "Test1",
    Location: "Noida, UP",
    type: "Type 1",
    fireRating: "DF20",
    compliance: "compliance 1",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test2",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test3",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test4",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test5",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test6",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test7",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test8",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test9",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test10",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test11",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test12",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test13",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test14",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test15",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test16",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test17",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test18",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test19",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
  {
    doorReference: "Test20",
    Location: "Noida, UP",
    type: "Type 2",
    fireRating: "DF20",
    compliance: "compliance 2",
    urgency: "urgency 1",
    comments: "comments 1",
  },
];

export const headCells = [
  {
    id: "doorRefNumber",
    numeric: false,
    disablePadding: true,
    label: "Door Reference",
  },
  // {
  //   id: "propertyLocation",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Location",
  // },
  {
    id: "doorType",
    numeric: true,
    disablePadding: true,
    label: "Type",
  },
  {
    id: "fireRating",
    numeric: true,
    disablePadding: true,
    label: "Fire Rating",
  },
  {
    id: "compliance",
    numeric: true,
    disablePadding: true,
    label: "Compliant",
  },
  // {
  //   id: "urgency",
  //   numeric: true,
  //   disablePadding: true,
  //   label: "Urgency",
  // },
  {
    id: "comments",
    numeric: true,
    disablePadding: true,
    label: "Comments",
  },
  {
    id: "view",
    numeric: true,
    disablePadding: true,
    label: "View",
  },
  {
    id: "edit",
    numeric: true,
    disablePadding: true,
    label: "Edit",
  },
];

export const UserRoles = {
  ADMIN: 1,
  INSPECTOR: 2,
  APPROVER: 3,
};

export const Statuses = {
  COMPLETED: "Completed",
  INREVIEW: "In Review",
  NOTSTARTED: "Not Started",
  INPROGRESS: "In Progress",
  REJECTED:"Rejected",
  SUBMITTEDFORAPPROVAL:"Submitted for Approval",
  DOORUNDERREVIEW: "Under Review",
  PENDINGFORAPPROVAL: "Awaiting Review",
  DOORAPPROVED: "Approved",
  REQUESTFORCHANGE: "Revision Required",
  COMPLIANT: "Compliant",
  NONCOMPLIANT: "Non-Compliant",
  // CRITICAL: "Non-Compliant: Critical",
  CANCELLED: "Cancelled",
  SCHEDULED: "Scheduled",
  NEW: "New",
  PENDINGINSPECTORAPPROVAL: "Pending Acceptance",
  PENDING: "Pending",
  HIGH :"High",
  URGENT : "Urgent",
  MEDIUM : "Medium",
  LOW : "Low",
  CRITICAL :"Critical"
};

export const Paths = {
  DASHBOARD: "/dashboard",
  VIEW_SURVEY: "/viewSurvey/:doorRefNumber",
  EDIT_SURVEY: "/editSurvey/:doorRefNumber",
  APPROVAL: "/approval/:propertyMasterId",
  PROPERTY_FORM: "/property-form",
  PROPERTY_VIEW_DETAILS: "/property-view-details/:propertyMasterId",
  SCAN_DOOR: "/scanDoor",
  MY_BOOKING: "/myBooking",
  CLIENT_DASHBOARD: "/clientDashboard",
  MY_PROPERTIES: "/myProperties",
  SUBSCRIPTION: "/subscription",
  MEMBERS: "/members"
}

export const DOOR_STATUS_IDS = {
  PENDINGFORAPPROVAL: 1,
  REQUESTFORCHANGE: 2,
  DOORAPPROVED: 3,
  SUBMITTEDFORAPPROVAL: 4,
}

export const COMPLIANCE_CHECK = {
  intumescentStrips: true,
  intumescentStripsTimeline: "Select",
  intumescentStripsSeverity: "Select",
  intumescentStripsComments: "",
  intumescentStripsCategory: "Select",
  intumescentStripsDueDate: "",
  intumescentStripsRemediation: "",
  intumescentStripsName: "Are there intumescent strips?",
  intumescentStripsId: "927da4a9-3c0b-46a7-8fb2-00af566a41e6",
  coldSmokeSeals: true,
  coldSmokeSealsTimeline: "Select",
  coldSmokeSealsSeverity: "Select",
  coldSmokeSealsComments: "",
  coldSmokeSealsCategory: "Select",
  coldSmokeSealsDueDate: "",
  coldSmokeSealsRemediation: "",
  coldSmokeSealsName: "Are there cold smoke seals?",
  coldSmokeSealsId: "2d46bbc6-3a52-48ee-ad7d-80c3f3cdf352",
  selfClosingDevice: true,
  selfClosingDeviceTimeline: "Select",
  selfClosingDeviceSeverity: "Select",
  selfClosingDeviceComments: "",
  selfClosingDeviceCategory: "Select",
  selfClosingDeviceDueDate: "",
  selfClosingDeviceRemediation: "",
  selfClosingDeviceName: "Self closing device?",
  selfClosingDeviceId: "145baf7e-bcc6-4c8f-b925-070e751ba2d6",
  fireLockedSign: true,
  fireLockedSignTimeline: "Select",
  fireLockedSignSeverity: "Select",
  fireLockedSignComments: "",
  fireLockedSignCategory: "Select",
  fireLockedSignDueDate: "",
  fireLockedSignRemediation: "",
  fireLockedSignName: "Fire door Keep Locked sign?",
  fireLockedSignId: "942c7963-7d98-49db-a13e-63ee7b4fcfd1",
  fireShutSign: true,
  fireShutSignTimeline: "Select",
  fireShutSignSeverity: "Select",
  fireShutSignComments: "",
  fireShutSignCategory: "Select",
  fireShutSignDueDate: "",
  fireShutSignRemediation: "",
  fireShutSignName: "Fire door Keep Shut sign?",
  fireShutSignId: "b7157137-2bfc-423d-b236-6620c527519b",
  holdOpenDevice: true,
  holdOpenDeviceName: "Is there a hold open device?",
  holdOpenDeviceId: "a106ba4e-ef40-4510-851e-09d1315becc5",
  visibleCertification: true,
  visibleCertificationName: "Is certification visible on fire door?",
  visibleCertificationId: "99ab902f-794a-491b-a6e3-26c8a57f9527",
  doorGlazing: true,
  doorGlazingName: "Does the door contain glazing?",
  doorGlazingId: "1b2886cc-a1a3-4573-a5be-7df68c0db109",
  pyroGlazing: true,
  pyroGlazingTimeline: "Select",
  pyroGlazingSeverity: "Select",
  pyroGlazingComments: "",
  pyroGlazingCategory: "Select",
  pyroGlazingDueDate: "",
  pyroGlazingRemediation: "",
  pyroGlazingName: "Is glazing pyro glazing?",
  pyroGlazingId: "c9873267-e600-4c99-bf08-088dee277909",
  doorCloseFully: true,
  doorCloseFullyTimeline: "Select",
  doorCloseFullySeverity: "Select",
  doorCloseFullyComments: "",
  doorCloseFullyCategory: "Select",
  doorCloseFullyDueDate: "",
  doorCloseFullyRemediation: "",
  doorCloseFullyName: "Does the door close fully?",
  doorCloseFullyId:"5a2ef13a-8b8c-4591-a502-4502e328be89",
  damageToDoor: false,
  damageToDoorTimeline: "Select",
  damageToDoorSeverity: "Select",
  damageToDoorComments: "",
  damageToDoorCategory: "Select",
  damageToDoorDueDate: "",
  damageToDoorRemediation: "",
  damageToDoorName: "Any damage to the door?",
  damageToDoorId: "9809bb26-f0e4-4ae7-a60d-469c0746e73d",
  visualDefectsToDoor: false,
  visualDefectsToDoorTimeline: "Select",
  visualDefectsToDoorSeverity: "Select",
  visualDefectsToDoorComments: "",
  visualDefectsToDoorCategory: "Select",
  visualDefectsToDoorDueDate: "",
  visualDefectsToDoorRemediation: "",
  visualDefectsToDoorName: "Any visual defects on the door?",
  visualDefectsToDoorId:"7d8ed99f-1c6b-4f9c-969e-0b3c3ff79bf5",
  visualDefectsToDoorDamageType: "Select",
  hingesFireRated: true,
  hingesFireRatedTimeline: "Select",
  hingesFireRatedSeverity: "Select",
  hingesFireRatedComments: "",
  hingesFireRatedCategory: "Select",
  hingesFireRatedDueDate: "",
  hingesFireRatedRemediation: "",
  hingesFireRatedName: "Are all hinges fire rated?",
  hingesFireRatedId: "5c5caf0c-131d-434b-aaf7-089d8c420ea4",
  hingesFireRatedRating: "Select",
};
export const FORM_DATA = {
  buildingName: "",
  doorLocation: "",
  doorNumber: "",
  doorType: "Select",
  doorColor: "Select",
  doorColorOther: "",
  doorMaterial: "Select",
  doorMaterialOther: "",
  GlazingDoor: "Select",
  glazingDoorLabel: "",
  doorTypeName: "",
  doorOther: "",
  doorPhotos: [],
  fireResistance: "Select",
  head: null,
  headTimeline: "Select",
  headSeverity: "Select",

  headComments: "",
  headCategory: "Select",
  headDueDate: "",
  headRemediation: "",
  headPredefined: "",
  hinge: null,
  hingeLocation: "Select",
  noOfHinges: null,
  noOfHingestimeline: "Select",
  noOfHingesSeverity: "Select",
  noOfHingesComments: "",
  noOfHingesCategory: "Select",
  noOfHingesDueDate: "",
  noOfHingesRemediation: "",
  hingeTimeline: "Select",
  hingeSeverity: "Select",
  hingeComments: "",
  hingeCategory: "Select",
  hingeDueDate: "",
  hingeRemediation: "",
  hingePredefined: "",
  closing: null,
  closingTimeline: "Select",
  closingSeverity: "Select",
  closingComments: "",
  closingCategory: "Select",
  closingDueDate: "",
  closingRemediation: "",
  closingPredefined: "",
  threshold: null,
  thresholdTimeline: "Select",
  thresholdSeverity: "Select",
  thresholdComments: "",
  thresholdCategory: "Select",
  thresholdDueDate: "",
  thresholdRemediation: "",
  thresholdPredefined: "",
  doorThickness: null,
  frameDepth: null,
  doorSize: null,
  fullDoorsetSize: null,
}
export const BASE_MEASURES = {
  head: 4,
  hinge: 4,
  closing: 4,
  threshold: 4,
  noOfHinges: 3,
};
export const AI_KEY_VALUES = {
  headTitle: "head",
  headUnit: "mm",
  headAction:{},
  hingeTitle: "hinge",
  hingeUnit: "mm",
  hingeAction:{},
  // noOfHingesTitle: "noofhinges",
  // noOfHingesUnit: "mm",
  // noOfHingesAction:{},
  closingTitle: "closing",
  closingUnit: "mm",
  closingAction:{},
  thresholdTitle: "threshold",
  thresholdUnit: "mm",
  thresholdAction:{},
  intumescentStripsTitle: "intustrips",
  intumescentStripsUnit: null,
  intumescentStripsAction:{},
  coldSmokeSealsTitle: "coldsmokeseals",
  coldSmokeSealsUnit: null,
  coldSmokeSealsAction:{},
  fireLockedSignTitle: "keepLockedSign",
  fireLockedSignUnit: null,
  fireLockedSignAction:{},
  fireShutSignTitle: "shutsign",
  fireShutSignUnit: null,
  fireShutSignAction:{},
  pyroGlazingTitle: "pyroglazing",
  pyroGlazingUnit: null,
  pyroGlazingAction:{},
  doorCloseFullyTitle: "doorclosefully",
  doorCloseFullyUnit: null,
  doorCloseFullyAction:{},
  // damageToDoorTitle: "damagetodoor",
  // damageToDoorUnit: null,
  // damageToDoorAction:{},
  // visualDefectsToDoorTitle: "visualdefects",
  // visualDefectsToDoorUnit: null,
  // visualDefectsToDoorAction:{},
  hingesFireRatedTitle: "hingesfirerated",
  hingesFireRatedUnit: null,
  hingesFireRatedAction:{},
}

export const AI_REMEDY_OPTIONS = {
  head: null,
  hinge: null,
  // noOfHinges:null,
  closing:null,
  threshold:null,
  intumescentStrips:null,
  coldSmokeSeals:null,
  fireLockedSign:null,
  fireShutSign:null,
  pyroGlazing:null,
  doorCloseFully:null,
  // damageToDoor:null,
  // visualDefectsToDoor:null,
  hingesFireRated:null,
}
export const BASE_MEASURES_COMP = {
  intumescentStrips: true,
  coldSmokeSeals: true,
  fireLockedSign: true,
  fireShutSign: true,
  pyroGlazing: true,
  doorCloseFully: true,
  damageToDoor: false,
  visualDefectsToDoor: false,
  hingesFireRated: true,
};

export const ACTION_MENU_FLAG = {
  head: false,
  hinge: false,
  closing: false,
  threshold: false,
  noOfHinges: false,
  intumescentStrips: false,
  coldSmokeSeals: false,
  selfClosingDevice: false,
  fireLockedSign: false,
  fireShutSign: false,
  pyroGlazing: false,
  doorCloseFully: false,
  damageToDoor: false,
  visualDefectsToDoor: false,
  hingesFireRated: false
};
export const ACTION_MENU_IMAGES = {
  head: [],
  hinge: [],
  closing: [],
  threshold: [],
  noOfHinges: [],
  intumescentStrips: [],
  coldSmokeSeals: [],
  selfClosingDevice: [],
  fireLockedSign: [],
  fireShutSign: [],
  pyroGlazing: [],
  doorCloseFully: [],
  damageToDoor: [],
  visualDefectsToDoor: [],
  hingesFireRated: [],
};

export const COMPLIANCE_CHECK_MASTER = {
  intumescentStripsId: "927da4a9-3c0b-46a7-8fb2-00af566a41e6",
  coldSmokeSealsId: "2d46bbc6-3a52-48ee-ad7d-80c3f3cdf352",
  selfClosingDeviceId: "145baf7e-bcc6-4c8f-b925-070e751ba2d6",
  fireLockedSignId: "942c7963-7d98-49db-a13e-63ee7b4fcfd1",
  fireShutSignId: "b7157137-2bfc-423d-b236-6620c527519b",
  holdOpenDeviceId: "a106ba4e-ef40-4510-851e-09d1315becc5",
  visibleCertificationId: "99ab902f-794a-491b-a6e3-26c8a57f9527",
  doorGlazingId: "1b2886cc-a1a3-4573-a5be-7df68c0db109",
  pyroGlazingId: "c9873267-e600-4c99-bf08-088dee277909",
  doorCloseFullyId: "5a2ef13a-8b8c-4591-a502-4502e328be89",
  damageToDoorId: "9809bb26-f0e4-4ae7-a60d-469c0746e73d",
  visualDefectsToDoorId: "7d8ed99f-1c6b-4f9c-969e-0b3c3ff79bf5",
  hingesFireRatedId: "5c5caf0c-131d-434b-aaf7-089d8c420ea4",
};

export const APPROVER_COMMENTS = {
  intumescentStrips: "",
  coldSmokeSeals: "",
  selfClosingDevice: "",
  fireLockedSign: "",
  fireShutSign: "",
  holdOpenDevice: "",
  visibleCertification: "",
  doorGlazing: "",
  pyroGlazing: "",
  doorCloseFully:"",
  damageToDoor: "",
  visualDefectsToDoor: "",
  hingesFireRated: "",
  fireResistance: "",
  head: "",
  hingeLocation: "",
  noOfHinges: "",
  hinge: "",
  closing: "", 
  threshold: "",
  doorThickness: "",
  frameDepth: "",
  doorSize: "",
  fullDoorsetSize: "",
};

export const APPROVER_CHECKBOX = {
  intumescentStrips: false,
  coldSmokeSeals: false,
  selfClosingDevice: false,
  fireLockedSign: false,
  fireShutSign: false,
  holdOpenDevice: false,
  visibleCertification: false,
  doorGlazing: false,
  pyroGlazing: false,
  doorCloseFully: false,
  damageToDoor: false,
  visualDefectsToDoor: false,
  hingesFireRated: false,
  fireResistance: false,
  head: false,
  hingeLocation: false,
  hinge: false,
  noOfHinges: false,
  closing: false, 
  threshold: false,
  doorThickness: false,
  frameDepth: false,
  doorSize:false,
  fullDoorsetSize:false,
};

export const dummyClientTile = [
  {
    tileId: 1,
    tileName: "Total Properties",
    tileValue: "5"
  },
  {
    tileId: 2,
    tileName: "Total Properties",
    tileValue: "5"
  },
  {
    tileId: 3,
    tileName: "Total Properties",
    tileValue: "5"
  },
  {
    tileId: 4,
    tileName: "Total Properties",
    tileValue: "5"
  }
];

export const dummyRecentActivities =[
  "First recent activity",
  "Second recent activity",
  "Third recent activity"
];

export const dummyMyProperties =[
  {
    name1: "Akhil",
    address1: "sbg1",
    contactno1: "16201345241",
    city: "Sahibganj",
    state: "Jharkhand",
  }
];
export const dummyPropertiesName = [
  { name: "Cosy Cottage 123, Main st, Abytown CA1" },
  { name: "Cosy Cottage 123, Main st, Abytown CA2" },
  { name: "Cosy Cottage 123, Main st, Abytown CA3" },
];

export const dummyPlans = [
    {
      title: "Pay as you go",
      price: "",
      features: [
        "Access to basic features",
        "Unlimited users",
        "Inspection Report",
        "Limited Storage",
        "Standard support",
      ],
    },
    // {
    //   title: "Enterprise plan",
    //   price: "$9.99",
    //    features: [
    //     "Access to basic features",
    //     "Limited Storage",
    //     "Standard support",
    //   ],
    // },
  ];
  export const dummyMemberName = [
  { name: "Rohit Singh" },
  { name: "Subham Singh" },
  { name: "Akhil Singh" },
  { name: "Nikhil S Jojare" },
  
];

export const propertyOptions = [
   { value: "property1", label: "Property 1" },
  { value: "property2", label: "Property 2" },
  { value: "property3", label: "Property 3" },
];

export const sampleInspectorRows =  [
  { id: 1, propertyName: '123 Maple Street', inspector: 'Jane Doe', date: '20/07/2024', status: 'Awaiting review' },
  { id: 2, propertyName: '456 Oak Avenue', inspector: 'John Smith', date: '20/07/2024', status: 'Scheduled' },
  { id: 3, propertyName: '789 Pine Lane', inspector: 'Emily White', date: '20/07/2024', status: 'Completed' },
  { id: 4, propertyName: '101 Elm Street', inspector: 'Michael Brown', date: '20/07/2024', status: 'Awaiting review' },
  { id: 5, propertyName: '202 Cedar Road', inspector: 'Jessica Davis', date: '20/07/2024', status: 'Scheduled' },
];

export const MARKETING_CONSTANT = [
  {id: 1, title: "Email Marketing", description: "Receive exclusive offers, product updates, and industry insights via email.", isChecked: false},
  {id: 2, title: "SMS Notifications", description: "Get important updates and time-sensitive offers via text message.", isChecked: false},
  {id: 3, title: "Newsletter Subscription", description: "Stay informed with our monthly newsletter featuring tips, trends and case studies.", isChecked: false},
  {id: 4, title: "Product Updates & Feature Releases", description: "Be the first to know about new features, improvements, and platform updates.", isChecked: false},
  {id: 5, title: "Special Offers & Discounts", description: "Receive exclusive discounts, early-bird offers, and limited-time promotions.", isChecked: false},
];